import React from 'react';
import './App.css';
import './materialize.min.css';
import ReactGA from 'react-ga';

class AvgDmgView extends React.Component {
    
    render () {
        const table = this.props;
        return (
            <div>
            <div class='row'>
                <h4 class='center-align'> Average Damage by AC </h4>
              </div>
              <table id='dmgavg'>
                <thead>
                  <tr>
                    {table["index"].map((c) =>
                        <th class='center-align' key={c}> {c} </th>)}
                  </tr>
                </thead>
                <tbody>
                  {table.dmg_avgs.map((row, index) =>
                      <td class='center-align' key={row[0]}> {row[0].toFixed(1)} </td>
                  )}
                </tbody>
              </table>
            </div>
        )
    }
}

// Colors generated by
// import seaborn as sns
// def to_hex(rgb, alpha):
//     r,g,b = rgb
//     return '#%02x%02x%02x%02x' % (int(r*256), int(g*256), int(b*256), alpha)
// [to_hex(x, 128) for x in sns.color_palette('RdBu_r', 7)]
function colormap(v, min, max){
    max = max + 1e-10
    const colors = ['#2971b280', '#6badd180', '#c2deec80', '#f8f7f780', '#fbccb480', '#e5806680', '#ba273280']
    v = (v-min)/(max-min)
    const step = 1 / colors.length
    return colors[Math.floor(v/step)]
}


class ResultView extends React.Component {
    render() {
        const { error, isLoaded, table} = this.props;
        if (error) {
            console.log(error)
          return <div>Error: {error.message}</div>;
        } else if (!isLoaded) {
          return <div>Loading...</div>;
        } else {
          return (
              <div>
              <div class='row'>
                <h4 class='center-align'> Average Turns to Kill by HP and AC</h4>
             </div>
             <table id='turngrid'>
              <thead>
                <tr>
                  <th> </th>
                  {table["columns"].map((c) =>
                      <th class='center-align' key={c}> {c} </th>)
}
                </tr>
              </thead>
              <tbody>
                {table.data.map((row, index) =>
                    <tr>
                    <td class='index' key={table.index[index]}> {table.index[index]} </td>
                    {row.map((col) =>
                        <td class='center-align' style={{'background-color': colormap(col, table.data_min, table.data_max)}} key={String(row) + '_' + String(col)}> {col.toFixed(1)} </td>
                    )}
                    </tr>)}
              </tbody>
              </table>
              </div>
         );
        }
  }
}


class CalcForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        form_data: {
            attacks_per_turn: 1, 
            dmg_dice: '1d6', 
            attack_modifier: 5, 
            dmg_modifier: 3, 
            crit_on: '20', 
            sharpshooter_gwm: false, 
            crit_multiplier: 2, 
            has_advantage: false,
        },
        show_results: false,
    }
    this.handleClick = this.handleClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
      ReactGA.initialize('UA-111706427-2');
      if (window.location.search !== ""){
          const kvs = window.location.search.slice(1).split('&').map((s) => s.split('='))
          const form_data = Object.fromEntries(kvs)
          if ('sharpshooter_gwm' in form_data){
              form_data['sharpshooter_gwm'] = form_data['sharpshooter_gwm'] === 'true'
          }
          if ('has_advantage' in form_data){
              form_data['has_advantage'] = form_data['has_advantage'] === 'true'
          }
          console.log(form_data)
          this.setState({form_data: {...this.state.form_data, ...form_data}});
      }
  }

  getTheStuff(){
    fetch("https://wmo4dcqbqc.execute-api.us-east-1.amazonaws.com/prod/turns-to-kill",
          {
         // mode: 'cors',
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
          //    'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(this.state.form_data)
          })
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            table: result
          });
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error: error
          });
        }
      )
  }
  
  handleClick(){
      ReactGA.event({
          action: 'simulate',
          category: 'simulate',
      });
      const form_data = this.state.form_data;
      const query_string = Object.keys(form_data).map((k) => k + "=" + String(form_data[k])).join('&');
      window.history.pushState(null, null, "?" + query_string);

      this.getTheStuff()

      //console.log(this.state);
      //this.setState({show_results: true});

      //console.log('end');
      //console.log(this.state);


  }

  handleInputChange(event) {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const name = target.name;

      this.setState({form_data: {...this.state.form_data, [name]: value}});
  }


  render() {

    let res;
     if (this.state.table) {
         res = <ResultView {...this.state} />
     } else {
        res = <div> Click button to see results </div>
     }

    return (
      <div>
        <div class='row'>
            <div class='col s3'> Attacks per turn
                <input name='attacks_per_turn' value={this.state.form_data.attacks_per_turn} onChange={this.handleInputChange}/>
            </div>
            <div class='col s3'> Attack modifier
                <input name='attack_modifier' value={this.state.form_data.attack_modifier} onChange={this.handleInputChange}/>
            </div>
            <div class='col s3'> 
                <label>
                    <input class='valign-wrapper' name='has_advantage' type='checkbox' checked={this.state.form_data.has_advantage} onChange={this.handleInputChange}/>
                    <span style={{color: 'black'}}>Have Advantage?</span>
                </label>
            </div>
            <div class='col s3'> 
                <label>
                    <input class='valign-wrapper' name='sharpshooter_gwm' type='checkbox' checked={this.state.form_data.sharpshooter_gwm} onChange={this.handleInputChange}/>
                    <span style={{color: 'black'}}>Sharpshooter or Great Weapon Master</span>
                </label>
            </div>
        </div>

        <div class='row'>
            <div class='col s3'> Damage dice
                <input name='dmg_dice' value={this.state.form_data.dmg_dice} onChange={this.handleInputChange}/>
            </div>
            <div class='col s3'> Damage modifier
                <input name='dmg_modifier' value={this.state.form_data.dmg_modifier} onChange={this.handleInputChange}/>
            </div>
            <div class='col s3'> Critical hit on
                <input name='crit_on' value={this.state.form_data.crit_on} onChange={this.handleInputChange}/>
            </div>
            <div class='col s3'> Crit multiplier
                <input name='crit_multiplier' value={this.state.form_data.crit_multiplier} onChange={this.handleInputChange}/>
            </div>

        </div>
        
        <div class='row'>
                    </div>
        <div class='row'>
            <button class='col s4 offset-s4 btn-large' onClick={this.handleClick}> Simulate </button>
        </div>
        {res}
      </div>
    );
  }
}

function App() {
  return (
      <div>

      <h1>Damage Calculator</h1>
        <CalcForm/>
      </div>
      );
}

export default App;
